import { useCreateCollection } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collection-mutations/useCreateCollection.js';
import { useCreateCollectionForThread } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collection-mutations/useCreateCollectionForThread.js';
import { DEFAULT_SPACE_ACCESS_LEVEL } from '#pplx/frontend/components/utils/consts.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
export const useCreateNewSpace = () => {
    const { $t } = useIntl();
    const router = useRouter();
    const { mutate: createCollection } = useCreateCollection({
        reason: 'create-new-space',
    });
    const { mutate: createCollectionForThread } = useCreateCollectionForThread({
        reason: 'create-new-space',
    });
    const handleCreateNewSpace = useCallback(() => {
        const titleFallback = $t({
            defaultMessage: 'New Space',
            description: 'Default title used when creating a new space',
            id: '2a028166ee',
        });
        createCollection({
            title: titleFallback,
            description: '',
            emoji: '',
            instructions: '',
            accessLevel: DEFAULT_SPACE_ACCESS_LEVEL,
            callback: (collection) => {
                router.push(`/spaces/${collection.slug}`);
            },
        });
    }, [createCollection, $t, router]);
    const handleCreateNewSpaceForThread = useCallback((entryUUID, frontendContextUUID) => {
        const titleFallback = $t({
            defaultMessage: 'New Space',
            description: 'Default title used when creating a new space for a thread',
            id: 'c74f960115',
        });
        createCollectionForThread({
            title: titleFallback,
            description: '',
            emoji: '',
            instructions: '',
            accessLevel: DEFAULT_SPACE_ACCESS_LEVEL,
            entryUUID,
            frontendContextUUID,
            callback: (collection) => {
                router.push(`/spaces/${collection.slug}`);
            },
        });
    }, [createCollectionForThread, $t, router]);
    return useMemo(() => ({ handleCreateNewSpace, handleCreateNewSpaceForThread }), [handleCreateNewSpace, handleCreateNewSpaceForThread]);
};
//# sourceMappingURL=useCreateNewSpace.js.map